<template>
    <div class="mobile-page clearfix" :style="{ marginTop: `${configData.mbConfig.val}px` }">
        <div class="bg"
             :style="{background: `linear-gradient(90deg,${configData.bgColor.color[0].item} 0%,${configData.bgColor.color[1].item} 100%)`,}"
             v-if="configData.bgColor.color.length > 0 && configData.isShow.val"></div>
        <div class="banner"
             :style="{paddingLeft: configData.lrConfig.val + 'px',paddingRight: configData.lrConfig.val + 'px',}">
            <img :class="{ doc: configData.imgConfig.type }" :src="configData.swiperConfig.list[0].img" alt=""
                 v-if="configData.swiperConfig.list[0].img"/>
            <div class="empty-box" :class="{ on: configData.imgConfig.type }" v-else>
                <span class="iconfont icontupian"></span>
            </div>
        </div>
        <div style="z-index: 99;position: relative">
            <div class="dot"
                 :style="{paddingLeft: configData.lrConfig.val + 10 + 'px',paddingRight: configData.lrConfig.val + 10 + 'px',justifyContent: (configData.txtStyle.type===1?'center':configData.txtStyle.type===2?'flex-end':'flex-start')}"
                 v-if="configData.docConfig.type == 0">
                <div class="dot-item" :style="{background: `${configData.dotColor.color[0].item}`}"></div>
                <div class="dot-item"></div>
                <div class="dot-item"></div>
            </div>
            <div class="dot line-dot"
                 :style="{paddingLeft: configData.lrConfig.val + 10 + 'px',paddingRight: configData.lrConfig.val + 10 + 'px',justifyContent: (configData.txtStyle.type===1?'center':configData.txtStyle.type===2?'flex-end':'flex-start')}"
                 v-if="configData.docConfig.type == 1">
                <div class="line_dot-item " :style="{background: `${configData.dotColor.color[0].item}`}"></div>
                <div class="line_dot-item"></div>
                <div class="line_dot-item"></div>
            </div>
            <div class="dot number"
                 :style="{paddingLeft: configData.lrConfig.val + 10 + 'px',paddingRight: configData.lrConfig.val + 10 + 'px',justifyContent: (configData.txtStyle.type===1?'center':configData.txtStyle.type===2?'flex-end':'flex-start')}"
                 v-if="configData.docConfig.type == 2">
                <div class="num">1/3</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "swiper",
        cname: '轮播图',
        sort: 1,
        type: 0, // 0 基础组件 1 营销组件 2工具组件
        icon: 'icontupianguanggao1',
        props: {
            configData: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                defaultConfig: {
                    name: "swiper",
                    cname: '轮播图',
                    tabs: [
                        {
                            title: '内容设置'
                        },
                        {
                            title: '样式设置'
                        }
                    ],
                    styles: {
                        // 图片列表
                        swiperConfig: {
                            tab: 0,
                            name: 'images',
                            title: "最多可添加10张图片，建议宽度750px；鼠标拖拽左侧圆点可调整图片 顺序",
                            maxList: 10,
                            showTitle: true,
                            list: [
                                {
                                    img: "",
                                    info: [
                                        {
                                            title: "标题",
                                            value: "今日推荐",
                                            tips: "选填，不超过4个字",
                                            max: 4,
                                        },
                                        {
                                            title: "链接",
                                            value: "",
                                            tips: "请输入链接",
                                            max: 100,
                                        },
                                    ],
                                },
                            ],
                        },
                        // 图片样式
                        imgConfig: {
                            tab: 1,
                            name: 'radio',
                            cname: "docStyle",
                            title: "轮播图样式",
                            type: 0,
                            list: [
                                {
                                    val: "圆角",
                                    icon: "iconPic_fillet",
                                },
                                {
                                    val: "直角",
                                    icon: "iconPic_square",
                                },
                            ],
                        },
                        // 轮播图点样式
                        docConfig: {
                            tab: 1,
                            name: 'radio',
                            cname: "swiper",
                            title: "指示器样式",
                            type: 0,
                            list: [
                                {
                                    val: "圆形",
                                    icon: "iconDot",
                                },
                                {
                                    val: "直线",
                                    icon: "iconSquarepoint",
                                },
                                {
                                    val: "数字",
                                    icon: "iconshuzi",
                                },
                                {
                                    val: "无指示器",
                                    icon: "iconjinyong",
                                },
                            ],
                        },
                        txtStyle: {
                            tab: 1,
                            name: 'radio',
                            title: '指示器位置',
                            type: 0,
                            list: [
                                {
                                    val: '居左',
                                    icon: 'icondoc_left'
                                },
                                {
                                    val: '居中',
                                    icon: 'icondoc_center'
                                },
                                {
                                    val: '居右',
                                    icon: 'icondoc_right'
                                }
                            ]
                        },
                        isShow: {
                            tab: 1,
                            name: 'editorswitch',
                            title: '是否显示背景色',
                            val: true
                        },
                        // 背景颜色
                        bgColor: {
                            tab: 1,
                            name: 'colors',
                            title: "背景颜色(渐变)",
                            default: [
                                {
                                    item: "#4985FD",
                                },
                                {
                                    item: "#4985FD",
                                },
                            ],
                            color: [
                                {
                                    item: "#4985FD",
                                },
                                {
                                    item: "#4985FD",
                                },
                            ],
                        },
                        dotColor: {
                            tab: 1,
                            name: 'colors',
                            title: "指示器颜色",
                            default: [
                                {
                                    item: "#fff",
                                },
                            ],
                            color: [
                                {
                                    item: "#fff",
                                },
                            ],
                        },
                        // 左右间距
                        lrConfig: {
                            tab: 1,
                            name: 'slider',
                            title: "左右边距",
                            val: 10,
                            min: 0,
                        },
                        // 页面间距
                        mbConfig: {
                            tab: 1,
                            name: 'slider',
                            title: "页面间距",
                            val: 0,
                            min: 0,
                        },
                    }
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .empty-box {
        height: 170px;
    }

    .mobile-page {
        position: relative;
        width: auto;
        position: relative;
        overflow: hidden;
        .bg {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            z-index: 1;
            width: 100%;
            height: 50px;
            background: linear-gradient(90deg, #F62C2C 0%, #F96E29 100%);
        }
        .banner {
            width: 100%;
            position: relative;
            box-sizing: border-box;
            z-index: 2;
            top: 2px;
            img {
                width: 100%;
                height: 100%;
                border-radius: 6px;

                .doc {
                    border-radius: 0;
                }
            }
        }
    }

    .dot {
        position: absolute;
        left: 0;
        bottom: 20px;
        width: 100%;
        display: flex;
        align-items: center;
        box-sizing: border-box;

        .number {
            bottom: 4px;
        }

        .num {
            width: 25px;
            height: 18px;
            line-height: 18px;
            background-color: #000;
            color: #fff;
            opacity: 0.3;
            border-radius: 8px;
            font-size: 12px;
            text-align: center;
        }

        .dot-item {
            width: 5px;
            height: 5px;
            background: #AAAAAA;
            border-radius: 50%;
            margin: 0 3px;
        }

        .line-dot {
            bottom: 20px;

            .line_dot-item {
                width: 8px;
                height: 2px;
                background: #AAAAAA;
                margin: 0 3px;
            }
        }
    }
</style>
